// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"1a4cfae2","372":"353db0f2","856":"73d58969"}[chunkId] + ".chunk.js";
};